import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { type Post } from "../schema";

const useArticle = (articleSlug: string): [Post, boolean, string] => {
  const [article, setArticle] = useState<Post>();
  const [isLoadingArticle, setIsLoadingArticle] = useState<boolean>(true);
  const [authorId, setAuthorId] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    let cancelRequest = false;
    const fetchArticleData = async () => {
      try {
        const response = await fetch(
          import.meta.env.VITE_GET_ARTICLE + articleSlug + "?increase_view_count=1",
          { method: "GET" }
        );
        if (!response.ok) {
          throw new Error(
            `error code: ${response.status}, The article you are looking for is not found `
          );
        }
        const { data } = await response.json();
        if (!cancelRequest) {
          setArticle(data);
          setAuthorId(data.post_meta.author_id);
          setIsLoadingArticle(false);
        }
      } catch (error) {
        console.log(error);
        navigate(`/404`);
      }
    };
    fetchArticleData();
    return () => {
      cancelRequest = true;
    };
  }, [articleSlug]);

  return [article as Post, isLoadingArticle, authorId];
};

export default useArticle;
